import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function useCaptcha() {
  const [captcha, setCaptcha] = useState({ a: 0, b: 0 });
  const [loading, setLoading] = useState(true);
  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/captcha");
      setCaptcha({ a: data.a, b: data.b });
    } catch {
      setCaptcha({
        a: Math.floor(Math.random() * 8) + 2,
        b: Math.floor(Math.random() * 8) + 2,
      });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
  }, []);
  return { captcha, reload: load, loading };
}
